const pushToDataLayer = (data) => {
  const { dataLayer } = window;
  console.log(`
    dataLayer.push({
      ${JSON.stringify(data, null, 2)},
    });
`);
  dataLayer.push(data);
};

const triggerCustomGAEvent = (options) => {
  const { action, category, label, value } = options;
  const data = {
    action,
    category,
    event: 'ga.event',
    label,
    value,
  };
  pushToDataLayer(data);
};

const triggerCustomGA4Event = (options) => {
  const {
    ecommerce,
    event,
    eventModel,
    pageModel,
  } = options;
  const data = {
    ...(ecommerce && { ecommerce }),
    event,
    ...(eventModel && { eventModel }),
    ...(pageModel && { pageModel }),
  };
  pushToDataLayer(data);
};

export {
  triggerCustomGAEvent,
  triggerCustomGA4Event,
};
